var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mfu-module"},[_c('VideoRecorder',{ref:"recorder",attrs:{"def":_vm.def},on:{"done":_vm.handleDone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }